export default __webpack_public_path__ + "static/media/NAG.1e684370.jpg";